import { SKILL_NAMES } from 'js/src/agent/skills/skillNames';
import type { Skill } from '../types';

import { AskUserQuestionTool } from 'js/src/agent/tools/AskUserQuestionTool';
import { SplitSceneGroupTool } from 'js/src/agent/tools/SplitSceneGroupTool';

export const editVideoDuration: Skill = {
    name: SKILL_NAMES.editVideoDuration,
    description:
        'The user wants the video shorter or longer. Load BEFORE making duration or pacing changes.',
    kind: 'howto',
    surfaces: ['sketch'],
    get instructions(): string {
        return `The user may commonly ask to make the video shorter or longer. This is an inherently ambiguous ask.

1. Determine the direction of the change. Are we making the video longer, or shorter?

2. Determine the magnitude of the change. Are we making it just a bit longer/shorter? Or substantially so?

3. (a) If the user is asking for something much longer, we should make sure we know what we’re adding. The user either wants more content (more detail) or potentially to slow down the pace of the video dramatically (split into more scenes, more time per scene, etc)
3. (b) If the user wants something much shorter we’ll need to understand what they want to cut out/focus on.
3. (c) If the user is asking for something slightly longer or shorter, we have a couple knobs. For text videos (or parts of videos), we can adjust the scene duration. For AI voiceover scene groups, we can adjust the AI voiceover speed. Talking-head and recorded-voiceover groups have a fixed duration — the recording is what it is and there is no trim tool, so say so plainly and offer what IS adjustable (the surrounding text scenes, or ask for a re-recorded/pre-trimmed upload). Do NOT fake a trim with ${SplitSceneGroupTool.toolName} or scene deletion.

4. Think carefully about which options make the most sense to achieve the desired result, and then rank those options.

5. Ask the user using the \`${AskUserQuestionTool.toolName}\` tool (unless you are sure you understand their desired outcome). Rank the questions from best to worst - the most naive option should not be the first option.
Do not include low ranking, bad ideas when asking the user. For example, should i make everything 3x as fast is a bad idea and it will annoy the user.`;
    },
};
